module.exports = __webpack_public_path__ + "static/media/yt.b6042b9c.svg";